import { render } from "./Navbar14View.vue?vue&type=template&id=5a42bb82"
const script = {}

import exportComponent from "E:\\2023-1\\sukun\\Sukun-Psikotes-FE-Peserta\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__